import { Controller } from "@hotwired/stimulus"

// Handles switching between manual URL entry and selecting a Copywriting URL.
export default class extends Controller {
  static targets = [
    "modeInput",
    "manualGroup",
    "copywritingGroup",
    "urlInput",
    "copywritingSelect",
    "copywritingId"
  ]

  static values = {
    manualRequired: { type: Boolean, default: false }
  }

  connect() {
    this.manualValue = this.urlInputTarget?.value || ""
    this.updateMode()
    if (this.currentMode === "copywriting") {
      this.applyCopywriting()
    }
  }

  switchMode() {
    this.updateMode()
  }

  applyCopywriting() {
    if (!this.hasCopywritingSelectTarget) return

    const option = this.copywritingSelectTarget.selectedOptions[0]
    if (!option) {
      this.copywritingIdTarget.value = ""
      return
    }

    this.copywritingIdTarget.value = option.value || ""
    const url = option.dataset.url
    if (url && this.hasUrlInputTarget) {
      this.urlInputTarget.value = url
    }
  }

  rememberManualValue() {
    if (this.currentMode === "manual") {
      this.manualValue = this.urlInputTarget.value
    }
  }

  updateMode() {
    const manualMode = this.currentMode !== "copywriting"
    const hasSelect = this.hasCopywritingSelectTarget
    const selectValue = hasSelect ? this.copywritingSelectTarget.value : ""

    this.manualGroupTarget.classList.toggle("hidden", !manualMode)
    this.copywritingGroupTarget.classList.toggle("hidden", manualMode)

    if (this.hasUrlInputTarget) {
      this.urlInputTarget.readOnly = !manualMode
      this.urlInputTarget.required = manualMode && this.manualRequiredValue
      if (manualMode) {
        this.urlInputTarget.value = this.manualValue
        this.copywritingIdTarget.value = ""
      } else if (!hasSelect || !selectValue) {
        this.urlInputTarget.value = ""
      }
    }
  }

  get currentMode() {
    const checked = this.modeInputTargets.find((input) => input.checked)
    return checked ? checked.value : "manual"
  }
}
